import { Routes } from '@angular/router';
import { roleGuard, rootSystemAdminGuard } from '../../../lib/guards/admin-role.guard';

export const aiFeatureProviderRoutes: Routes = [
  {
    path: 'ai-feature-provider',
    data: { title: 'AI 기능별 Provider 설정' },
    canActivate: [roleGuard('ADMIN_MASTER'), rootSystemAdminGuard],
    loadComponent: () =>
      import(
        './components/ai-feature-provider-list-page.component'
      ).then((m) => m.AiFeatureProviderListPageComponent),
  },
];
